/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Submit_ErrorInputs */

const en_consumer_declaration_submit_error = /** @type {(inputs: Consumer_Declaration_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The declaration could not be submitted. Your receipt ID is preserved; retry without changing the declaration.`)
};

const de_consumer_declaration_submit_error = /** @type {(inputs: Consumer_Declaration_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Erklärung konnte nicht übermittelt werden. Ihre Eingangs-ID bleibt erhalten; versuchen Sie es ohne Änderungen erneut.`)
};

const fr_consumer_declaration_submit_error = /** @type {(inputs: Consumer_Declaration_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La déclaration n’a pas pu être envoyée. L’identifiant est conservé ; réessayez sans la modifier.`)
};

const es_consumer_declaration_submit_error = /** @type {(inputs: Consumer_Declaration_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo enviar la declaración. Se conserva el ID; vuelve a intentarlo sin modificarla.`)
};

const it_consumer_declaration_submit_error = /** @type {(inputs: Consumer_Declaration_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio non riuscito. L’ID è conservato; riprova senza modificare la dichiarazione.`)
};

const nl_consumer_declaration_submit_error = /** @type {(inputs: Consumer_Declaration_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De verklaring kon niet worden verzonden. De ID blijft bewaard; probeer opnieuw zonder wijzigingen.`)
};

const pl_consumer_declaration_submit_error = /** @type {(inputs: Consumer_Declaration_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wysłać oświadczenia. ID zachowano; spróbuj ponownie bez zmian.`)
};

const fi_consumer_declaration_submit_error = /** @type {(inputs: Consumer_Declaration_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitusta ei voitu lähettää. Tunnus säilyy; yritä uudelleen muuttamatta ilmoitusta.`)
};

const da_consumer_declaration_submit_error = /** @type {(inputs: Consumer_Declaration_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erklæringen kunne ikke sendes. Id’et bevares; prøv igen uden ændringer.`)
};

const sv_consumer_declaration_submit_error = /** @type {(inputs: Consumer_Declaration_Submit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förklaringen kunde inte skickas. Id:t sparas; försök igen utan ändringar.`)
};

/**
* | output |
* | --- |
* | "The declaration could not be submitted. Your receipt ID is preserved; retry without changing the declaration." |
*
* @param {Consumer_Declaration_Submit_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_submit_error = /** @type {((inputs?: Consumer_Declaration_Submit_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Submit_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_submit_error(inputs)
	if (locale === "fr") return fr_consumer_declaration_submit_error(inputs)
	if (locale === "es") return es_consumer_declaration_submit_error(inputs)
	if (locale === "it") return it_consumer_declaration_submit_error(inputs)
	if (locale === "nl") return nl_consumer_declaration_submit_error(inputs)
	if (locale === "pl") return pl_consumer_declaration_submit_error(inputs)
	if (locale === "fi") return fi_consumer_declaration_submit_error(inputs)
	if (locale === "da") return da_consumer_declaration_submit_error(inputs)
	if (locale === "sv") return sv_consumer_declaration_submit_error(inputs)
	return en_consumer_declaration_submit_error(inputs)
});